import {
  AccessibilitySection,
  BikeSection,
  ConstructionSection,
  FoodSection,
  ParkingSection,
  ShuttleSection,
  Sidebar,
  TransportationSection,
} from '@uofu-uss-gis/ui-react';
import ClassMapDirectionsSection from './ClassMapDirectionsSection';

function ClassMapSidebar() {
  return (
    <Sidebar>
      <ClassMapDirectionsSection key="directions" />
      <TransportationSection key="transportation" />
      <BikeSection key="bike" />
      <ShuttleSection key="shuttle" />
      <ParkingSection key="parking" />
      <FoodSection key="food" />
      <AccessibilitySection key="accessibility" />
      <ConstructionSection key="construction" />
    </Sidebar>
  );
}

export default ClassMapSidebar;
